import { render, staticRenderFns } from "./Representantes.vue?vue&type=template&id=3996bdb9&scoped=true&lang=pug"
import script from "./Representantes.vue?vue&type=script&lang=js"
export * from "./Representantes.vue?vue&type=script&lang=js"
import style0 from "./Representantes.styl?vue&type=style&index=0&id=3996bdb9&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3996bdb9",
  null
  
)

export default component.exports